export const version = {
  hash: '061b7728'
};
